/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetCorporationsCorporationIdNotFound
 */
export interface GetCorporationsCorporationIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetCorporationsCorporationIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdNotFound interface.
 */
export function instanceOfGetCorporationsCorporationIdNotFound(value: object): value is GetCorporationsCorporationIdNotFound {
    return true;
}

export function GetCorporationsCorporationIdNotFoundFromJSON(json: any): GetCorporationsCorporationIdNotFound {
    return GetCorporationsCorporationIdNotFoundFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCorporationsCorporationIdNotFoundToJSON(json: any): GetCorporationsCorporationIdNotFound {
    return GetCorporationsCorporationIdNotFoundToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdNotFoundToJSONTyped(value?: GetCorporationsCorporationIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

